<div class="gifpicker">
    <button type="button" (click)="showGifs()" aria-label="choisir un gif" class="gif-picker-button">
        <img src="/assets/images/gif.svg">
    </button>

    @if(show){
    <div class="gif-picker">
        <div class="search-input">
            <div class="position-relative">
                <input type="text" class="form-control" [formControl]="searchInputCtrl" placeholder="{{'search_gif' | translate}} {{gifProvider}}" autocomplete="off">
                @if(searchLoading){
                <i class="far fa-spinner fa-spin"></i>
                } @else {
                <i class="fa fa-search"></i>
                }
            </div>
        </div>
        <div class="gifs-list">
            @for(gif of gifs; track gif.id){
            <button type="button" (click)="addGif(gif)">
                <img src="{{gif.url}}" alt="">
            </button>
            }
        </div>
    </div>
    }
</div>